<div class="advanced-settings">
  <div class="w-100 d-flex justify-content-end">
    <span class="btn btn-sm btn-outline-secondary" style="display: flex; gap: 0.3rem; align-items: center" routerLink="/rewards"> Use My {{ userInfo.points }} <img class="gold-coin" src="../../../../../assets/images/gold-coin.png"  /> </span>
  </div>

  <div class="content">
    <div class="content__title">Contributions</div>
    <div class="grid-contributions">
      <div class="stats">
        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #28a745">
            <i class="fa-solid fa-thumbs-up"></i>
          </div>
          <div>
            <div class="stats-title">Likes</div>
            <div class="stats-value">
              {{ questStats?.likes || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #dc3545">
            <i class="fa-solid fa-flag"></i>
          </div>
          <div>
            <div class="stats-title">Reports</div>
            <div class="stats-value">
              {{ questStats?.reports || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #ffc107">
            <i class="fa-solid fa-lightbulb"></i>
          </div>
          <div>
            <div class="stats-title">Suggestions</div>
            <div class="stats-value">
              {{ questStats?.suggest || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #ffc107">
            <i class="fa-solid fa-pen"></i>
          </div>
          <div>
            <div class="stats-title">Surveys Given</div>
            <div class="stats-value">
              {{ questStats?.reviews || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #ffc107">
            <i class="fa-solid fa-question-circle"></i>
          </div>
          <div>
            <div class="stats-title">Ask Posts</div>
            <div class="stats-value">
              {{ questStats?.askPosts || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #ffc107">
            <i class="fa fa-check"></i>
          </div>
          <div>
            <div class="stats-title">Service/Product Posted</div>
            <div class="stats-value">
              {{ questStats?.productPosts || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #078fff">
            <i class="fas fa-hand-point-right"></i>
          </div>
          <div>
            <div class="stats-title">Recommendations</div>
            <div class="stats-value">
              {{ questStats?.recommendationsCount || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon">
            <i class="fa-solid fa-image"></i>
          </div>
          <div>
            <div class="stats-title">Moments Posts</div>
            <div class="stats-value">
              {{ questStats?.momentsCount || 0 }}
            </div>
          </div>
        </div>

        <div class="stats-card shadow">
          <div class="stats-icon" style="color: #eec718">
            <i class="fa-solid fa-plus"></i>
          </div>
          <div>
            <div class="stats-title">Experiences Given</div>
            <div class="stats-value">
              {{ questStats?.xpCount || 0 }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="content__box" style="max-height: 31rem; overflow-y: scroll; overflow-x: hidden">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Points Received</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let reward of rewardsRecieved">
                  <td>{{ reward.updatedAt | date : "short" }}</td>
                  <td>
                    @if(reward.points){
                    {{ reward.points }}
                    } @else{
                    <button class="btn" style="color: var(--secondary)">Limit Exceeded</button>
                    }
                  </td>
                  <td>
                    <button class="t-btn">
                      {{ changeRewardKeyName(reward.actionType) }}
                    </button>
                  </td>
                </tr>
                <tr *ngIf="rewardsRecieved.length === 0">
                  <td colspan="4" class="text-center">No Rewards Received.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <nav *ngIf="quest.totalPages > 1" aria-label="Quest pagination" class="mt-3">
            <ul class="pagination justify-content-center mb-0">
              <li class="page-item" [class.disabled]="quest.page === 1">
                <button class="page-link" (click)="initQuest({ page: quest.page - 1 })" [disabled]="quest.page === 1">&laquo;</button>
              </li>
              <li class="page-item" *ngFor="let p of [].constructor(quest.totalPages); let i = index" [class.active]="quest.page === i + 1">
                <button class="page-link" (click)="initQuest({ page: i + 1 })">{{ i + 1 }}</button>
              </li>
              <li class="page-item" [class.disabled]="quest.page === quest.totalPages">
                <button class="page-link" (click)="initQuest({ page: quest.page + 1 })" [disabled]="quest.page === quest.totalPages">&raquo;</button>
              </li>
            </ul>
          </nav>
        </div>
        <!---------------------------------------------------------------->
        <div class="content__box" style="max-height: 31rem; overflow-y: scroll; overflow-x: hidden">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Points Used</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let usage of pointsUsed">
                  <td>{{ usage.updatedAt | date : "short" }}</td>
                  <td>
                    @if(usage.points){
                    {{ usage.points }}
                    } @else{
                    <button class="btn" style="color: var(--secondary)">Limit Exceeded</button>
                    }
                  </td>
                  <td>
                    <button class="t-btn">
                      {{ usage.actionType }}
                    </button>
                  </td>
                </tr>
                <tr *ngIf="pointsUsed.length === 0">
                  <td colspan="4" class="text-center">No Points Used.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <nav *ngIf="quest.totalPages > 1" aria-label="Quest pagination" class="mt-3">
            <ul class="pagination justify-content-center mb-0">
              <li class="page-item" [class.disabled]="quest.page === 1">
                <button class="page-link" (click)="initQuest({ page: quest.page - 1 })" [disabled]="quest.page === 1">&laquo;</button>
              </li>
              <li class="page-item" *ngFor="let p of [].constructor(quest.totalPages); let i = index" [class.active]="quest.page === i + 1">
                <button class="page-link" (click)="initQuest({ page: i + 1 })">{{ i + 1 }}</button>
              </li>
              <li class="page-item" [class.disabled]="quest.page === quest.totalPages">
                <button class="page-link" (click)="initQuest({ page: quest.page + 1 })" [disabled]="quest.page === quest.totalPages">&raquo;</button>
              </li>
            </ul>
          </nav>
        </div>
        <!---------------------------------------------------------------->
        <div class="profile-mini">
          <div class="profile-mini__body">
            <div class="level" [class.fit-height]="openShepherd">
              <div class="title-mobile">Profile</div>
              <img loading="lazy" class="img" src="/assets/images/new/badge.png" />
              <div class="phone">
                {{ maskNumber(userInfo?.phone) || "" }}
              </div>
              <div class="all">
                <span> {{ userInfo?.points || 0 }} PTS / {{ userInfo?.requirePoints || 0 }} PTS</span>
                <div class="diamonds" (click)="openBuyDiamonds()">
                  <div class="diamonds__text">{{ diamonds }}</div>
                  <img loading="lazy" class="diamonds__img" src="/assets/images/diamond.png" />
                </div>
              </div>
              <ngb-progressbar [animated]="true" [value]="userInfo?.progressBarValue || 0" [striped]="true"></ngb-progressbar>
              <div class="hexagon">{{ userInfo?.level }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
